import Vue from "vue";
import setVH from "./lib/setVH";
import HeaderNav from "./components/HeaderNav";
import Brain from "./components/Brain";
import Slide from "./components/Slide";
import ThreeSides from "./components/ThreeSides";
import ImageContainer from "./components/ImageContainer";
import CityList from "./components/CityList";
import CityItem from "./components/CityItem";
import Video from "./components/Video";
import FamilyMemberBio from "./components/FamilyMemberBio";
import Splash from "./components/Splash";
import DevelopmentList from "./components/DevelopmentList";

Vue.component(
  "croustille-carousel",
  require("./components/StackCarousel.vue").default
);

function defineCustomElements() {
  window.customElements.define("croustille-header-nav", HeaderNav);
  window.customElements.define("croustille-slide", Slide);
  window.customElements.define("croustille-three-sides", ThreeSides);
  window.customElements.define("croustille-image-container", ImageContainer);
  window.customElements.define("croustille-city-list", CityList);
  window.customElements.define("croustille-city-item", CityItem);
  window.customElements.define("croustille-family-member-bio", FamilyMemberBio);
  window.customElements.define("croustille-splash", Splash);
  window.customElements.define("croustille-video", Video);
  window.customElements.define("croustille-development-list", DevelopmentList);
}

defineCustomElements();

document.addEventListener("DOMContentLoaded", function () {
  Brain.init();

  window.addEventListener("resize", setVH);
  setVH();
});
